// Resume, in the composer of a session that ended and may be resumed
// (Poulpe-425): `resume_session`, which reopens its agent's conversation in
// its worktree. The server refuses it, and says why, when its runner would
// not take it; an agent that cannot reload its conversation says so as the
// session ends again. Today's words (code/Composer.tsx there).
import { useState } from 'react'
import { errorMessage } from '../api/client'
import type { Session } from '../api/types'
import { uuid4 } from '../api/uuid'
import { useMounted } from '../components/layout'
import { needsServer } from '../components/needsServer'
import { toast } from '../components/toasts'
import { useBoardState, useStore } from '../store/context'

export function ResumeButton({ session }: { session: Session }) {
  const store = useStore()
  const { offline } = useBoardState()
  const mounted = useMounted()
  const [resuming, setResuming] = useState(false)
  const resume = () => {
    if (resuming || store.getState().offline || session.allowance?.stopped) return
    setResuming(true)
    store
      .sendSessionOp({ mutation_id: uuid4(), op: 'resume_session', args: { session_id: session.id } })
      .catch((err: unknown) => toast(`Could not resume the session: ${errorMessage(err)}`, 'error'))
      .finally(() => {
        if (mounted.current) setResuming(false)
      })
  }
  return (
    <button type="button" className="button button-small" disabled={resuming || offline || !!session.allowance?.stopped} title={session.allowance?.stopped ?? undefined} {...needsServer(offline)} onClick={resume}>
      {resuming ? 'Resuming…' : 'Resume'}
    </button>
  )
}
